import { useBexApi } from '@shared-ui/bex-api-context';
import { ActivityDestinationViewSearch, ActivitySort, DateInput } from 'src/common/__generated__/api/types';
import useActivitySearchQuery from '../hooks/useActivitySearchQuery';

interface ActivityDataByIdsProps {
  regionName: string,
  regionId: string,
  startDate: DateInput,
  endDate: DateInput,
  size?: number,
}

const ActivityDataByIds = (props: ActivityDataByIdsProps) => {
  const { regionName, regionId, startDate, endDate, size } = props;
  const { context } = useBexApi();

  const activityDestinationViewSearchVariables: ActivityDestinationViewSearch.Variables = {
    context,
    "destination": {
      "regionName": regionName,
      "regionId": regionId,
      "coordinates": null
    },
    "dateRange": {
      "startDate": startDate,
      "endDate": endDate
    },
    "filters": {
      "selections": [
        {
          "id": "sort",
          "value": "RECOMMENDED"
        }
      ]
    },
    "sort": ActivitySort.RECOMMENDED,
    "marketing": {
      "sem": null,
      "semdtl": null
    },
    "pagination": {
      "size": size || 50,
      "startingIndex": 0
    },
  };

  const { data, error, loading } = useActivitySearchQuery(activityDestinationViewSearchVariables);
  return { data, error, loading };
}

export { ActivityDataByIds, ActivityDataByIdsProps }